const colors = {
  brand: {
    400: `#025285`,
    500: `#025285`,
  },
};

export default colors;
